<template>
  <div class="bgView">
    <div class="loginBox">
      <header class="loginBoxHeader">
        <div class="loginBoxTitle">密码登录</div>
        <img class="closeBtn" :src="closeImg"  @click="cancelBtnClicked"/>
      </header>
      <div class="loginBoxBody">
        <div class="loginItem">
          <img class="loginItemImg" :src="userImg"/>
          <input class="loginItemInput"  v-model="username" placeholder="请输入用户名" 
          maxlength="18"/>
        </div>
        <div class="loginItem">
          <img class="loginItemImg" :src="passwordImg"/>
          <input class="loginItemInput" :type="isShowPassword?'text':'password'" 
          v-model="password" placeholder="请输入密码"
          maxlength="18" />
          <img class="passwordVisibleImg" :src="isShowPassword?eyeSeeImg:eyeHideImg"
          @click="reversePasswordVisibility"/>
        </div>
        <div class="loginBtn" @click="login">登录</div>
      </div>
    </div>
   
  </div>
  
</template>

<script>
import axios from 'axios'

export default {
  name: 'Main',
  data () {
    return {
      username:'',
      password:'',
      isShowPassword:false,
      closeImg: require("../assets/images/close.png"),
      userImg: require("../assets/images/user.png"),
      passwordImg: require("../assets/images/password.png"),
      eyeHideImg:require("../assets/images/eye_hide.png"),
      eyeSeeImg:require("../assets/images/eye_see.png"),
    }
  },
  mounted() {
   
  },
  methods: {
    cancelBtnClicked() {
      this.$emit("receiveClose")
    },
    reversePasswordVisibility() {
      this.isShowPassword = !this.isShowPassword;
    },
    login() {
      console.log("username = ",this.username);
      console.log("password = ",this.password);

      if(this.username.length == 0) {
        // $alertBox.alert({
        //  message:"用户名不能为空"
        // })
        this.$message({
          type: 'warning',
          message: '用户名不能为空'
        })
        return;
      }

      if(this.password.length == 0) {
        // $alertBox.alert({
        //  message:"密码不能为空"
        // })
        this.$message({
          type: 'warning',
          message: '密码不能为空'
        })
        return;
      }

      let url = baseIp + 'user/login'
      let json = {
        username:this.username,
        password:this.password,
      }
      let param = this.$jsEncrypt(JSON.stringify(json))
      // let param = JSON.stringify(json)
      let config = {
        headers:{
          'Content-Type':'application/json; charset=utf-8',
        
          "Access-Control-Allow-Origin":'*'
        }
        
      };
     
      console.log(url);

      axios.post( url,param,config)
      .then((res)=>{
        console.log(res);
        console.log(res.data); 
        if (res.data.code ==200) {
          this.$message({
              type: 'success',
              message: '登录成功'
            })
          //存储token
            localStorage.setItem('token',res.data.data);
           this.$emit("onLoginSuccess");
            
        }
        else {
            // alert(res.data.message);
            // $confirm.alert({
            //   content: res.data.result
            // });
            // $alertBox.alert({

            //   message:res.data.message
            // })
            this.$message({
              type: 'error',
              message: res.data.message
            })
        }
       

      })
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


.bgView {
  width:100%;
  height: 100%;
  top:60px;
  left:0;
  position: absolute;
  background: #000000a0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loginBox {
  width:320px;
  height: auto;
  background: white;
   border-radius: 8px;
}

.loginBoxHeader {
  width:100%;
  height: 40px;
  position: relative;
  border-bottom: 1px solid black;
  
}
.loginBoxTitle {
  width:100%;
  height:100%;
  position:absolute;
  color: #222226;
  font-size:16px;
  line-height: 40px;
}

.closeBtn {
  width: 20px;
  height: 20px;
  right:20px;
  top:10px;
  position: absolute;
  cursor: pointer;
}

.loginBoxBody {
  width:calc(100% - 20px);
  height: auto;
  padding:10px;

}

.loginItem {
  height: 40px;
  display: flex;
  align-items: center;
  border: 1px solid #cccccc;
  border-radius: 4px;
  margin-bottom: 10px;
  padding-left: 10px;
  padding-right: 10px;
  position: relative;
}
.loginItemImg {
  width:20px;
  height: 20px;
  position:relative;
}
.loginItemInput {
  height:30px;
  padding-left: 10px;
}
.passwordVisibleImg {
  width: 20px;
  height: 20px;
  right:20px;
  position: absolute;
}
.loginBtn {
  
  width: 100%;
  height: 40px;
  color: #fff;
  line-height: 40px;
  background-color: #007fff;
  border-radius: 2px;
  outline: none;
  box-sizing: border-box;
  cursor: pointer;
  margin-top: 20px;
}

.loginBoxFooter {
   width:100%;
  height: 40px;
  position: relative;
  border-top: 1px solid black;
}
.cancelBtn {
  width:100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue